import { render } from "./site-detail.vue?vue&type=template&id=58072f6a&scoped=true"
import script from "./site-detail.vue?vue&type=script&lang=js"
export * from "./site-detail.vue?vue&type=script&lang=js"

import "./site-detail.vue?vue&type=style&index=0&id=58072f6a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58072f6a"]])

export default __exports__